import { easyEstimatorApi } from '../easyEstimatorService';

import { ApiUrl } from '~/core/enums';
import { PricedProduct, ProductEstimateQuery } from '~/core/models';

const pricedProductsApi = easyEstimatorApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchProductsPrices: builder.query<
      PricedProduct[],
      { data?: ProductEstimateQuery }
    >({
      query: ({ data }) => ({
        url: ApiUrl.PRICES,
        method: 'POST',
        data,
      }),
    }),
  }),
});

export const { useFetchProductsPricesQuery, useLazyFetchProductsPricesQuery } =
  pricedProductsApi;
